import { render, staticRenderFns } from "./calculator.vue?vue&type=template&id=5beda026&scoped=true"
import script from "./calculator.vue?vue&type=script&lang=js"
export * from "./calculator.vue?vue&type=script&lang=js"
import style0 from "./calculator.vue?vue&type=style&index=0&id=5beda026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beda026",
  null
  
)

export default component.exports